import SmoothScroll from './SmoothScroll';
import Navigation from './Navigation';
import ToTop from './ToTop';

(() => {
  const init = () => {
    SmoothScroll(-80);
    Navigation();
    ToTop();
  };

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  document.addEventListener('touchstart', (event) => {}, { passive: true });
  document.addEventListener('wheel', (event) => {}, { passive: true });
})();
